(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["pawly-journal"] && !Shopify.designMode) return;
  try {
    
(function() {
  var BREEDS = [
    {id:'golden',name:'Golden Retriever',taille:'grand',icon:'🦮',desc:'Grande race'},
    {id:'labrador',name:'Labrador',taille:'grand',icon:'🐕',desc:'Grande race'},
    {id:'berger_a',name:'Berger Allemand',taille:'grand',icon:'🐕‍🦺',desc:'Grande race'},
    {id:'berger_au',name:'Berger Australien',taille:'grand',icon:'🐕',desc:'Grande race'},
    {id:'husky',name:'Husky Sibérien',taille:'grand',icon:'🐺',desc:'Grande race'},
    {id:'malinois',name:'Malinois Belge',taille:'grand',icon:'🐕‍🦺',desc:'Grande race'},
    {id:'rottweiler',name:'Rottweiler',taille:'grand',icon:'🐕',desc:'Grande race'},
    {id:'dobermann',name:'Dobermann',taille:'grand',icon:'🐕',desc:'Grande race'},
    {id:'bernois',name:'Bouvier Bernois',taille:'grand',icon:'🦮',desc:'Grande race'},
    {id:'setter',name:'Setter Irlandais',taille:'grand',icon:'🐕',desc:'Grande race'},
    {id:'dalmatien',name:'Dalmatien',taille:'grand',icon:'🐕',desc:'Grande race'},
    {id:'leonberg',name:'Leonberg',taille:'grand',icon:'🦁',desc:'Grande race'},
    {id:'border',name:'Border Collie',taille:'moyen',icon:'🐩',desc:'Race moyenne'},
    {id:'cocker',name:'Cocker Spaniel',taille:'moyen',icon:'🐶',desc:'Race moyenne'},
    {id:'boxer',name:'Boxer',taille:'moyen',icon:'🐕',desc:'Race moyenne'},
    {id:'bulldog_a',name:'Bulldog Anglais',taille:'moyen',icon:'🐶',desc:'Race moyenne'},
    {id:'bulldog_f',name:'Bulldog Français',taille:'moyen',icon:'🐶',desc:'Race moyenne'},
    {id:'beagle',name:'Beagle',taille:'moyen',icon:'🐕',desc:'Race moyenne'},
    {id:'shiba',name:'Shiba Inu',taille:'moyen',icon:'🦊',desc:'Race moyenne'},
    {id:'whippet',name:'Whippet',taille:'moyen',icon:'🐕',desc:'Race moyenne'},
    {id:'staff',name:'Staffordshire',taille:'moyen',icon:'🐕',desc:'Race moyenne'},
    {id:'sharpei',name:'Shar-Peï',taille:'moyen',icon:'🐶',desc:'Race moyenne'},
    {id:'chow',name:'Chow-Chow',taille:'moyen',icon:'🦁',desc:'Race moyenne'},
    {id:'samoyede',name:'Samoyède',taille:'moyen',icon:'🐺',desc:'Race moyenne'},
    {id:'jack',name:'Jack Russell',taille:'petit',icon:'🐾',desc:'Petite race'},
    {id:'chihuahua',name:'Chihuahua',taille:'petit',icon:'🐾',desc:'Petite race'},
    {id:'yorkshire',name:'Yorkshire',taille:'petit',icon:'🐾',desc:'Petite race'},
    {id:'bichon',name:'Bichon Frisé',taille:'petit',icon:'🐩',desc:'Petite race'},
    {id:'maltais',name:'Maltais',taille:'petit',icon:'🐩',desc:'Petite race'},
    {id:'caniche',name:'Caniche Toy',taille:'petit',icon:'🐩',desc:'Petite race'},
    {id:'pomeranien',name:'Poméranien',taille:'petit',icon:'🦊',desc:'Petite race'},
    {id:'shih',name:'Shih Tzu',taille:'petit',icon:'🐶',desc:'Petite race'},
    {id:'cavalier',name:'Cavalier K.C.',taille:'petit',icon:'🐶',desc:'Petite race'},
    {id:'pinscher',name:'Pinscher Nain',taille:'petit',icon:'🐾',desc:'Petite race'},
    {id:'croise',name:'Croisé / Mixte',taille:'moyen',icon:'🐕',desc:'Toute taille'}
  ];
  var AGES = [2,3,4,5,6,8,10,12];

  function initSection(root) {
    if (root.dataset.pjInit) return;
    root.dataset.pjInit = '1';
    var state = { selBreed: null, selAge: null, curFilter: 'all' };
    var $ = function(sel) { return root.querySelector(sel); };
    var $$ = function(sel) { return root.querySelectorAll(sel); };

    function renderBreeds() {
      var list = state.curFilter === 'all' ? BREEDS : BREEDS.filter(function(b){ return b.taille === state.curFilter; });
      var html = list.map(function(b) {
        var sel = state.selBreed && state.selBreed.id === b.id ? 'selected' : '';
        return '<div class="pj-breed-btn ' + sel + '" data-breed="' + b.id + '">'
          + '<div class="pj-breed-icon">' + b.icon + '</div>'
          + '<div class="pj-breed-name">' + b.name + '</div>'
          + '<div class="pj-breed-size">' + b.desc + '</div>'
          + '</div>';
      }).join('');
      $('.pj-breed-grid').innerHTML = html;
      $$('.pj-breed-btn').forEach(function(el) {
        el.addEventListener('click', function() { selectBreed(el.dataset.breed); });
      });
    }

    function renderAges() {
      var html = AGES.map(function(a) {
        var sel = state.selAge === a ? 'selected' : '';
        return '<div class="pj-age-btn ' + sel + '" data-age="' + a + '">'
          + '<div class="pj-age-num">' + a + '</div>'
          + '<div class="pj-age-unit">mois</div>'
          + '</div>';
      }).join('');
      $('.pj-age-grid').innerHTML = html;
      $$('.pj-age-btn').forEach(function(el) {
        el.addEventListener('click', function() { selectAge(parseInt(el.dataset.age, 10)); });
      });
    }

    function filterBreed(f, el) {
      state.curFilter = f;
      $$('.pj-filter').forEach(function(c){ c.classList.remove('on'); });
      el.classList.add('on');
      renderBreeds();
    }
    function selectBreed(id) {
      state.selBreed = BREEDS.find(function(b){ return b.id === id; });
      $('[data-btn="1"]').disabled = false;
      renderBreeds();
    }
    function selectAge(a) {
      state.selAge = a;
      $('[data-btn="2"]').disabled = false;
      renderAges();
    }
    function updateStep0() {
      var v = $('.pj-nom').value.trim();
      $('[data-btn="0"]').disabled = !v;
      $('.pj-age-label-nom').textContent = v || 'ton chiot';
    }

    function goStep(n) {
      $$('.pj-step').forEach(function(s){ s.classList.remove('on'); });
      $$('.pj-dot').forEach(function(d, i) {
        d.classList.remove('active','done');
        if (i < n) d.classList.add('done');
      });
      var activeStep = root.querySelector('.pj-step[data-step="' + n + '"]');
      if (activeStep) activeStep.classList.add('on');
      var activeDot = root.querySelector('.pj-dot[data-dot="' + n + '"]');
      if (activeDot) activeDot.classList.add('active');
      if (n === 1) renderBreeds();
      if (n === 2) renderAges();
    }

    function generate() {
      var nom = $('.pj-nom').value.trim();
      var race = state.selBreed;
      var age = state.selAge;
      var tailleMsg = {
        grand: 'Pour un ' + race.name + ', la croissance osseuse est active jusqu\'à 18 mois',
        moyen: 'Les ' + race.name + ' ont une croissance complète vers 12 mois',
        petit: 'Les ' + race.name + ' grandissent vite — souvent finis à 10 mois'
      }[race.taille];

      $('.pj-avatar').textContent = race.icon;
      $('.pj-journal-name').textContent = nom;
      $('.pj-journal-sub').textContent = race.name + ' · ' + age + ' mois';
      $('.pj-cta-nom').textContent = nom;

      var weeks = [
        {w:'S1–2', title:'Stabilisation digestive', pill:'Digestion', pc:'pill-dig',
         desc:'Dès les premiers jours, <span class="pj-name-hl">' + nom + '</span> tolère mieux ses repas. Les probiotiques Pawly équilibrent son microbiote — selles régulières, moins de ballonnements.'},
        {w:'S3–4', title:'Pelage plus brillant', pill:'Pelage', pc:'pill-pel',
         desc:'Les Oméga 3 & 6 entrent en action. Le pelage de <span class="pj-name-hl">' + nom + '</span> devient visiblement plus doux et brillant — très notable chez les ' + race.name + '.'},
        {w:'S5–6', title:'Immunité renforcée', pill:'Immunité', pc:'pill-imm',
         desc:'Le colostrum bovin IgG renforce les défenses naturelles de <span class="pj-name-hl">' + nom + '</span>. Moins de vulnérabilité aux infections à ' + (age + 1) + ' mois.'},
        {w:'S7–8', title:'Croissance osseuse optimale', pill:'Croissance', pc:'pill-cro',
         desc: tailleMsg + '. Les vitamines D & A soutiennent les os et articulations de <span class="pj-name-hl">' + nom + '</span> pendant cette phase critique.'},
        {w:'S8', title:'Vitalité complète', pill:'Résultat', pc:'pill-vit',
         desc:'Au bout d\'un pot, <span class="pj-name-hl">' + nom + '</span> dégage une énergie remarquable. Pelage brillant, digestion fluide, regard vif — les gens autour de toi vont le remarquer.'}
      ];

      var tlHtml = weeks.map(function(w, i) {
        var isFirst = i === 0;
        var hasLine = i < weeks.length - 1;
        return '<div class="pj-tl-item">'
          + '<div class="pj-tl-left">'
          + '<div class="pj-tl-circle ' + (isFirst ? 'active' : 'inactive') + '" data-tc="' + i + '">' + w.w + '</div>'
          + (hasLine ? '<div class="pj-tl-line pending" data-tl="' + i + '"></div>' : '')
          + '</div>'
          + '<div class="pj-tl-content ' + (isFirst ? 'active' : '') + '" data-tw="' + i + '">'
          + '<div class="pj-tl-head">'
          + '<span class="pj-tl-title">' + w.title + '</span>'
          + '<div style="display:flex;align-items:center;gap:6px;">'
          + '<span class="pj-tl-pill ' + w.pc + '">' + w.pill + '</span>'
          + '<span class="pj-tl-chevron ' + (isFirst ? 'open' : '') + '" data-tch="' + i + '">▾</span>'
          + '</div></div>'
          + '<div class="pj-tl-desc ' + (isFirst ? 'open' : '') + '" data-td="' + i + '">' + w.desc + '</div>'
          + '</div></div>';
      }).join('');
      $('.pj-timeline').innerHTML = tlHtml;

      $$('.pj-tl-content').forEach(function(el) {
        el.addEventListener('click', function() { toggleWeek(parseInt(el.dataset.tw, 10), weeks.length); });
      });

      $$('.pj-dot').forEach(function(d){ d.classList.remove('active','done'); d.classList.add('done'); });
      goStep(3);
      setTimeout(function() {
        var bar = $('.pj-progress-bar');
        if (bar) bar.style.width = '12%';
        var label = $('.pj-progress-label');
        if (label) label.textContent = 'Semaine 1 / 8';
      }, 400);
    }

    function toggleWeek(idx, total) {
      var desc = root.querySelector('[data-td="' + idx + '"]');
      var isOpen = desc.classList.contains('open');
      for (var i = 0; i < total; i++) {
        var d = root.querySelector('[data-td="' + i + '"]');
        var ch = root.querySelector('[data-tch="' + i + '"]');
        var tw = root.querySelector('[data-tw="' + i + '"]');
        var tc = root.querySelector('[data-tc="' + i + '"]');
        var tl = root.querySelector('[data-tl="' + i + '"]');
        if (d) d.classList.remove('open');
        if (ch) ch.classList.remove('open');
        if (tw) tw.classList.remove('active');
        if (tc) { tc.classList.remove('active'); tc.classList.add(i < idx ? 'done' : 'inactive'); }
        if (tl) { tl.classList.remove('done'); tl.classList.add('pending'); }
      }
      if (!isOpen) {
        desc.classList.add('open');
        root.querySelector('[data-tch="' + idx + '"]').classList.add('open');
        root.querySelector('[data-tw="' + idx + '"]').classList.add('active');
        var circle = root.querySelector('[data-tc="' + idx + '"]');
        if (circle) { circle.classList.remove('inactive','done'); circle.classList.add('active'); }
        for (var j = 0; j < idx; j++) {
          var cj = root.querySelector('[data-tc="' + j + '"]');
          var lj = root.querySelector('[data-tl="' + j + '"]');
          if (cj) { cj.classList.remove('inactive','active'); cj.classList.add('done'); }
          if (lj) { lj.classList.remove('pending'); lj.classList.add('done'); }
        }
        var bar = $('.pj-progress-bar');
        var label = $('.pj-progress-label');
        if (bar) bar.style.width = Math.round(((idx + 1) / total) * 85) + '%';
        if (label) label.textContent = 'Semaine ' + ((idx + 1) * 2 - 1) + ' / 8';
      }
    }

    $('.pj-nom').addEventListener('input', updateStep0);
    $$('.pj-filter').forEach(function(el) {
      el.addEventListener('click', function() { filterBreed(el.dataset.filter, el); });
    });
    $$('.pj-btn-next').forEach(function(el) {
      el.addEventListener('click', function() {
        if (el.classList.contains('pj-btn-generate')) { generate(); return; }
        var n = parseInt(el.dataset.btn, 10);
        goStep(n + 1);
      });
    });
    $$('.pj-btn-back, .pj-cta-reset').forEach(function(el) {
      el.addEventListener('click', function() { goStep(parseInt(el.dataset.back, 10)); });
    });
  }

  function init() {
    document.querySelectorAll('.pawly-journal').forEach(initSection);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

  } catch(e) { console.error(e); }
})();
})();
